import { defineComponent as i, Types as t } from "bitecs";
const r = i({
  gap: t.f32,
  align: t.ui8,
  anchorX: t.ui8,
  anchorY: t.ui8,
  damping: t.f32
}), u = i({
  fontSize: t.f32,
  color: t.ui32,
  letterSpacing: t.f32,
  lineHeight: t.f32,
  outlineWidth: t.f32,
  outlineColor: t.ui32,
  outlineBlur: t.f32,
  outlineOffsetX: t.f32,
  outlineOffsetY: t.f32,
  outlineOpacity: t.f32,
  strokeWidth: t.f32,
  strokeColor: t.ui32,
  strokeOpacity: t.f32,
  fillOpacity: t.f32,
  curveRadius: t.f32,
  width: t.f32,
  dirty: t.ui8
});
var o = /* @__PURE__ */ ((e) => (e[e.Left = 0] = "Left", e[e.Center = 1] = "Center", e[e.Right = 2] = "Right", e))(o || {});
export {
  o as Align,
  r as Paragraph,
  u as Word
};
//# sourceMappingURL=components.js.map
